import MainRoutes from './MainRoutes.js'
import {
  Link,
  BrowserRouter as Router
} from "react-router-dom"
import {Col, Row} from "react-bootstrap";
import { Provider, useDispatch } from 'react-redux'
import store from './store.js'
import Sidebar from "./Sidebar.js";
import { RiLogoutBoxRFill } from "react-icons/ri";
import { FaUserLarge } from "react-icons/fa6";
import { MdMarkEmailUnread } from "react-icons/md";
import { logout } from "./actions/auth.js";
import styled from "styled-components";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import { useState } from 'react';
import { useSelector } from 'react-redux';

const Nav = styled.div`
background: #15171c;
height: 50px;
display: flex;
justify-content: flex-start;
align-items: center;
`;

const notificationTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    View your notifications.
  </Tooltip>
);

const logoutTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to Log Out.
  </Tooltip>
);

const profileTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    View and edit your profile.
  </Tooltip>
); 

const TopAndSideBar = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  const dispatch = useDispatch();

  const handleLogout = () => {
    //e.preventDefault();		
    
    dispatch(logout())
    .then(() => {
      //props.history.push("/");
      window.location.reload();
    })
    .catch((e) => {
      console.log(e);
    });
  };

  
	return (		
    
      <>
			<Nav style={{position:'sticky', top:'0',zIndex:'10'}}>
        {/**
				<h4
					style={{width: "100%", 
							textAlign: "left",
              marginLeft: "20px",
							color: "#fff" }}
				>Fast Quoting System</h4>
        */}       
        {(!currentUser) &&
          
          <>
          <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignContent:'center', width:'100%',height:'100%'}}>
            <p style={{color:'white',margin:'auto'}}>
              You are in Guest Mode. Please, <a href='/login'>login</a> to save your work and unlock additional options: 
            </p>            
          </div>

          </>
        }

        {(currentUser) &&
          <>
          {(currentUser.roles.includes(3)) &&          
            <Sidebar sidebarStatus={false} />
          }

          <div style={{display:'flex',flexDirection:'row', width:'100%', justifyContent:'flex-end'}}>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={notificationTooltip}>        
              <div style={{ marginLeft:'50px',marginRight:'0px',verticalAlign:'center', borderStyle:'solid',borderWidth:'2px', borderColor:'white',borderRadius:'20px'}}>
                <MdMarkEmailUnread 
                  style={{cursor:'pointer'}}
                  color="white"        
                  size={25}
                  onClick={handleLogout}/>
              </div>
            </OverlayTrigger> 

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={profileTooltip}>        
              <div style={{marginLeft:'50px',marginRight:'0px',verticalAlign:'center', borderStyle:'solid',borderWidth:'2px', borderColor:'white',borderRadius:'20px'}}>
                  <Link to={"/viewuserprofile/" + currentUser.id} className="mr-2">
                    <FaUserLarge 
                      style={{cursor:'pointer'}}
                      color="white"        
                      size={25}>
                    </FaUserLarge>                          
                  </Link>             
              </div>
            </OverlayTrigger> 

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={logoutTooltip}>        
              <div style={{marginLeft:'40px',marginRight:'50px',verticalAlign:'center', borderStyle:'solid',borderWidth:'2px', borderColor:'white',borderRadius:'20px'}}>
                <RiLogoutBoxRFill 
                  style={{cursor:'pointer'}}
                  color="white"        
                  size={25}
                  onClick={handleLogout}/>
              </div>
            </OverlayTrigger>    
            </div>
          </>
        }
 		

			</Nav>  


      
      </>

  )
}

export default TopAndSideBar;